// src/circle-item/src/CircleItem.tsx
import * as React from "react";

// src/circle-item/src/CircleItem.css.ts
var circle = "CircleItem__7ezfp81";
var container = "CircleItem__7ezfp80";
var image = "CircleItem__7ezfp82";
var label = "CircleItem__7ezfp83";

// src/circle-item/src/CircleItem.tsx
function CircleItem({ image: image2, label: label2, link, width = 86 }) {
  return /* @__PURE__ */ React.createElement("a", { href: link, style: { pointerEvents: link ? "auto" : "none" } }, /* @__PURE__ */ React.createElement("div", { className: container }, /* @__PURE__ */ React.createElement("div", { className: circle, style: { width } }, /* @__PURE__ */ React.createElement("img", { className: image, src: image2, alt: label2 })), /* @__PURE__ */ React.createElement("div", { className: label, style: { maxWidth: width } }, label2)));
}
export {
  CircleItem as default
};
